import React from "react";
import NoContent from "../../../components/NoContent/NoContent";
import { Button } from "@mui/material";
import { CalendarAddIcon } from "../../../../../../components/Icons";

const TryAgain = ({ onTryAgain }: { onTryAgain: () => void }) => {
  return (
    <NoContent
      imageSrc="/assets/images/try-again.svg"
      imageAlt="Something went wrong illustration"
      title="Oops...Something Went Wrong!"
      description={
        <>
          We couldn’t load your prescriptions right now. <br />
          Please check your connection and try again.
        </>
      }
      customButton={
        <Button
          variant="contained"
          color="primary"
          onClick={onTryAgain}
          startIcon={<CalendarAddIcon />}
          sx={{
            width: "100%",
            maxWidth: "528px",
            fontSize: "16px",
            fontWeight: 600,
          }}
        >
          Try Again
        </Button>
      }
    />
  );
};

export default TryAgain;
